import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import styled from '@emotion/styled';

/**
 * 예전 안드로이드 앱(React Native, 2023 이전 플레이스토어판) 사용자에게 새 앱 설치 안내.
 * 예전 앱에는 지원이 끝난 카카오 SDK 가 들어 있어 2026-07 부터 카카오 로그인이 KOE033 오류로 막힘.
 * 예전 앱 UA: 'chordscore/Android/1.0.0.1 Mozilla/5.0 …', 새 앱(2.0~): '… chordscore/Android' (뒤에 버전 없음)
 */
export const isOldAndroidApp = () => /chordscore\/Android\/\d/.test(navigator.userAgent);

const APK_URL = 'https://chordscore.com/app/chordscore.apk';
const SESSION_KEY = 'oldAppNoticeShown';

const OldAppNotice: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!isOldAndroidApp()) return;
        try {
            if (sessionStorage.getItem(SESSION_KEY) === '1') return;
            sessionStorage.setItem(SESSION_KEY, '1');
        } catch (e) {
            // 저장소를 못 써도 안내는 띄운다
        }
        setOpen(true);
    }, []);

    if (!open) return null;

    const copy = () => {
        const done = () => setCopied(true);
        try {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(APK_URL).then(done).catch(() => null);
                return;
            }
        } catch (e) {
            // 아래 방식으로
        }
        const t = document.createElement('textarea');
        t.value = APK_URL;
        document.body.appendChild(t);
        t.select();
        try {
            document.execCommand('copy');
            done();
        } catch (e) {
            // 복사 실패: 주소를 보고 직접 입력
        }
        document.body.removeChild(t);
    };

    return ReactDOM.createPortal(
        <Dim>
            <Box role="dialog" aria-modal="true">
                <Title>새 앱으로 업데이트해 주세요</Title>
                <Body>
                    지금 쓰시는 앱은 예전 버전이라 <b>카카오 로그인이 되지 않아요.</b><br/>
                    아래 주소에서 새 앱을 설치하면 그대로 이어서 쓸 수 있어요.
                </Body>
                <Url>{APK_URL}</Url>
                <Steps>
                    1. 주소 복사 → 크롬(인터넷)에 붙여넣기<br/>
                    2. 내려받은 파일 열기 → 설치(업데이트)<br/>
                    <small>지금은 카카오 아이디·비밀번호로 로그인하실 수 있어요.</small>
                </Steps>
                <Buttons>
                    <Primary onClick={copy}>{copied ? '복사됐어요' : '주소 복사'}</Primary>
                    <Secondary onClick={() => setOpen(false)}>닫기</Secondary>
                </Buttons>
            </Box>
        </Dim>,
        document.body,
    );
};

export default OldAppNotice;

const Dim = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

const Box = styled.div`
  width: 100%;
  max-width: 360px;
  background: #fff;
  color: #1e1e1e;
  border-radius: 14px;
  padding: 22px 20px 18px;
  box-sizing: border-box;

  html[color-mode="dark"] & {
    background: #23252e;
    color: #fff;
  }
`;

const Title = styled.h2`
  margin: 0 0 12px;
  font-size: 19px;
  font-weight: 800;
  text-align: center;
`;

const Body = styled.p`
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
  word-break: keep-all;
`;

const Url = styled.div`
  font-size: 13px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f1f3f5;
  word-break: break-all;
  text-align: center;
  user-select: all;

  html[color-mode="dark"] & {
    background: #31343f;
  }
`;

const Steps = styled.p`
  margin: 12px 0 16px;
  font-size: 13px;
  line-height: 1.7;
  word-break: keep-all;

  small {
    color: #868e96;
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 8px;
`;

const Primary = styled.button`
  flex: 1;
  height: 46px;
  border: 0;
  border-radius: 10px;
  background: #2a5298;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
`;

const Secondary = styled.button`
  flex: 0 0 90px;
  height: 46px;
  border: 1px solid #ced4da;
  border-radius: 10px;
  background: transparent;
  color: inherit;
  font-size: 15px;
`;
